var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// packages/remirror__preset-react/src/index.ts
var src_exports = {};
__export(src_exports, {
  ReactExtension: () => ReactExtension
});
module.exports = __toCommonJS(src_exports);

// packages/remirror__preset-react/src/react-extension.ts
var import_core = require("@remirror/core");
var import_extension_placeholder = require("@remirror/extension-placeholder");
var import_extension_react_component = require("@remirror/extension-react-component");
var DEFAULT_OPTIONS = {
  ...import_extension_placeholder.PlaceholderExtension.defaultOptions,
  ...import_extension_react_component.ReactComponentExtension.defaultOptions
};
var STATIC_KEYS = [...import_extension_placeholder.PlaceholderExtension.staticKeys, ...import_extension_react_component.ReactComponentExtension.staticKeys];
var ReactExtension = class extends import_core.PlainExtension {
  get name() {
    return "react";
  }
  onSetOptions(props) {
    const { pickChanged } = props;
    this.getExtension(import_extension_placeholder.PlaceholderExtension).setOptions(pickChanged(["placeholder"]));
  }
  createExtensions() {
    const {
      emptyNodeClass,
      placeholder,
      defaultBlockNode,
      defaultContentNode,
      defaultEnvironment,
      defaultInlineNode,
      nodeViewComponents
    } = this.options;
    return [
      new import_extension_placeholder.PlaceholderExtension({
        emptyNodeClass,
        placeholder,
        priority: import_core.ExtensionPriority.Low
      }),
      new import_extension_react_component.ReactComponentExtension({
        defaultBlockNode,
        defaultContentNode,
        defaultEnvironment,
        defaultInlineNode,
        nodeViewComponents
      })
    ];
  }
};
ReactExtension = __decorateClass([
  (0, import_core.extension)({
    defaultOptions: DEFAULT_OPTIONS,
    staticKeys: STATIC_KEYS
  })
], ReactExtension);

// packages/remirror__preset-react/src/index.ts
__reExport(src_exports, require("@remirror/extension-placeholder"), module.exports);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ReactExtension,
  ...require("@remirror/extension-placeholder")
});
